import React from 'react';
import { FaGoogle, FaFacebookF } from 'react-icons/fa';
import './SocialMedia.css';

const SocialLogin: React.FC = () => {
  return (
    <div className="social-login-row">
      <button className="social-button google-button" type="button">
        <FaGoogle className="icon" />
        Sign with Google
      </button>

      <button className="social-button facebook-button" type="button">
        <FaFacebookF className="icon" />
        Sign with Facebook
      </button>
    </div>
  );
};

export default SocialLogin;
